import Icon from '../components/Icon.vue'

Icon.register({
  venus: {
    width: 288,
    height: 512,
    paths: [
      {
        d: 'M288 176c0 68.5-47.9 125.9-112 140.4v51.6h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-64.1-14.5-112-71.9-112-140.4 0-79.5 64.5-144 144-144s144 64.5 144 144zM64 176c0 44.1 35.9 80 80 80s80-35.9 80-80-35.9-80-80-80-80 35.9-80 80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/venus.js
// module id = 2085
// module chunks = 0